import React, { useEffect, useState } from 'react';
import { HBTableHeaderProps } from './HBTable.types';
import HBTableColumnHeader from './HBTableColumnHeader';
import { Table } from './HBTable.styles';
import HBTableHorizontalShadowSyncScrollContainer from './HBTableHorizontalShadowSyncScrollContainer';
import styled from 'styled-components';
import { vars } from '../../theme';

function HBTableColumnHeaders<T>({
    table,
    tableBodyEl
}: HBTableHeaderProps<T>) {
    const tdEls = useGetFirstRowTdEls(tableBodyEl);

    return (
        <HBTableHorizontalShadowSyncScrollContainer table={table}>
            <Table>
                <THead>
                    <tr>
                        {table.getAllColumns().map(column => (
                            <HBTableColumnHeader
                                table={table}
                                key={column.id}
                                column={column}
                                tdEl={tdEls[column.getIndex()]}
                            />
                        ))}
                    </tr>
                </THead>
            </Table>
        </HBTableHorizontalShadowSyncScrollContainer>
    );
}

export default HBTableColumnHeaders;

function useGetFirstRowTdEls(tableBodyEl: HTMLTableElement | null) {
    const [firstRowTdEls, setFirstRowTdEls] = useState<HTMLTableCellElement[]>(
        []
    );

    useEffect(() => {
        if (!tableBodyEl) {
            return;
        }
        function getFirstRowTdEls() {
            const _firstRowTdEls = tableBodyEl
                .querySelector('tr')
                ?.getElementsByTagName('td');

            if (_firstRowTdEls) {
                setFirstRowTdEls([..._firstRowTdEls]);
            }
        }
        getFirstRowTdEls();
        const observer = new MutationObserver(getFirstRowTdEls);
        observer.observe(tableBodyEl, {
            subtree: true,
            childList: true,
            attributes: true
        });

        return () => observer.disconnect();
    }, [tableBodyEl]);

    return firstRowTdEls;
}

// -------------------------- Styles -------------------------- //

const THead = styled.thead`
    table-layout: fixed;
    background-color: ${vars.colors.surface.itemInset};
`;
